module.exports = __webpack_public_path__ + "img/business.e7778af.svg";